import React, { useRef, useCallback } from 'react';
import { Typography } from '@mui/material';
import {
  Edit,
  useRecordContext,
  useTranslate,
  useNotify,
  useRedirect,
  EditProps,
} from 'react-admin';
import { Funeral } from '../types';
import { FuneralBaseEdit } from './FuneralBaseEdit';
import AuditTimeline from './AuditTimeline';
import { syncFuneralClientsAfterSave } from './FuneralClientsInput';

// We need to capture _funeral_clients before transform strips it
let pendingFuneralClients: any[] | null = null;

const transformFuneralData = (data: any) => {
  // Capture before stripping
  pendingFuneralClients = data._funeral_clients || null;

  const { _funeral_clients, ...rest } = data;
  // Remove any _fc_client_* temp fields from client autocompletes
  const cleaned = Object.fromEntries(
    Object.entries(rest).filter(([key]) => !key.startsWith('_fc_client_')),
  );
  return cleaned;
};

export const FuneralEdit = (props: EditProps) => {
  const notify = useNotify();
  const redirect = useRedirect();

  return (
    <Edit
      aside={<AuditTimeline />}
      title={<FuneralTitle />}
      redirect="show"
      mutationMode="pessimistic"
      transform={transformFuneralData}
      mutationOptions={{
        onSuccess: async (data: any) => {
          if (pendingFuneralClients) {
            await syncFuneralClientsAfterSave(data.id, pendingFuneralClients);
            pendingFuneralClients = null;
          }
          redirect('show', 'funerals', data.id);
        },
      }}
    >
      <FuneralBaseEdit />
    </Edit>
  );
};


const FuneralTitle = () => {
  const translate = useTranslate();
  const record = useRecordContext<Funeral>();
  return (
    <Typography>
      {translate('resources.funerals.title', {
        id: record ? `#${record.id}` : '',
      })}
    </Typography>
  );
};
